import { render } from "./OtherDetail.vue?vue&type=template&id=f9a3db8c"
import script from "./OtherDetail.vue?vue&type=script&lang=js"
export * from "./OtherDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__